'use client'

/**
 * Client news panel for the chart page (and any client surface). Fetches /api/news?symbol=… (which is
 * Redis-cached 30 min) and renders the shared StockNews list. Kept separate from the presentational
 * component so the chart can fetch on demand without the ticker page paying for a client fetch.
 */

import { useEffect, useState } from 'react'
import StockNews from './StockNews'
import type { NewsArticle } from '@/lib/news/stockNews'

export default function StockNewsPanel({ symbol, heading }: { symbol: string; heading?: string }) {
  const [items, setItems] = useState<NewsArticle[] | null>(null)

  useEffect(() => {
    let alive = true
    setItems(null)
    fetch(`/api/news?symbol=${encodeURIComponent(symbol)}`)
      .then((r) => (r.ok ? r.json() : null))
      .then((j) => { if (alive) setItems((j?.articles as NewsArticle[]) ?? []) })
      .catch(() => { if (alive) setItems([]) })
    return () => { alive = false }
  }, [symbol])

  if (items === null) return <div className="py-2 text-xs text-zinc-600">Loading {symbol} news…</div>
  if (!items.length) return null
  return <StockNews items={items} symbol={symbol} heading={heading} />
}
